module.exports = __webpack_public_path__ + "img/09.39f02584.jpg";